var _regeneratorRuntime = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/createClass");

(function () {
  if (typeof global !== "undefined") {// global already exists
  } else if (typeof window !== "undefined") {
    window.global = window;
  } else if (typeof self !== "undefined") {
    self.global = self;
  } else {
    throw new Error("cannot export (neither global, window nor self is defined)");
  }

  global.Formula =
  /*#__PURE__*/
  function () {
    "use strict";

    function _class(json, manifest) {
      _classCallCheck(this, _class);

      this.json = json;
      this.manifest = manifest;
      this.wasm = null;
      this.jsglue = null;
      this.jsglue_go = null;
      this.parameters = []; // validate actor

      if (!this.json.hasOwnProperty("actor")) throw new Error("Not found required property actor");
      if (!this.json.actor.hasOwnProperty("wasm")) throw new Error("Not found required property actor.wasm");
      this.wasm = new global.Manifest(this.json.actor.wasm);
      this.wasm.ArgName = "actor.wasm";

      if (this.json.actor.hasOwnProperty("jsglue")) {
        this.jsglue = new global.Manifest(this.json.actor.jsglue);
        this.jsglue.ArgName = "actor.jsglue";
      }

      if (this.json.actor.hasOwnProperty("jsglue_go")) {
        this.jsglue_go = new global.Manifest(this.json.actor.jsglue_go);
        this.jsglue_go.ArgName = "actor.jsglue_go";
      } // validate parameters


      if (!this.json.hasOwnProperty("parameters")) throw new Error("Not found required property parameters");

      for (var parameter in this.json.parameters) {
        var param = new global.Manifest(this.json.parameters[parameter]);
        param.ArgName = parameter;
        this.parameters.push(param);
      }

      ;
    }

    _createClass(_class, [{
      key: "get_dependencies",
      value: function get_dependencies() {
        var result = {
          status: "ok",
          data: []
        };
        result.data.push(this.wasm);
        if (this.jsglue) result.data.push(this.jsglue);
        if (this.jsglue_go) result.data.push(this.jsglue_go);
        this.parameters.forEach(function (parameter) {
          result.data.push(parameter);
        });
        return result;
      }
    }, {
      key: "eval",
      value: function () {
        var _eval2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(dependencies_data) {
          var result, wasm, jsglue, jsglue_go, args, parameter, ArgName, arg_data, wasm_wrapper, mime;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  result = {
                    status: "",
                    data: []
                  };
                  wasm = dependencies_data.get("actor.wasm");

                  if (!(null === wasm)) {
                    _context.next = 5;
                    break;
                  }

                  result.status = "Evaluation failed, has no actor.wasm data";
                  return _context.abrupt("return", result);

                case 5:
                  jsglue = null;
                  jsglue_go = null;

                  if (!this.jsglue) {
                    _context.next = 12;
                    break;
                  }

                  jsglue = dependencies_data.get("actor.jsglue");

                  if (!(null == jsglue)) {
                    _context.next = 12;
                    break;
                  }

                  result.status = "Evaluation failed, has no actor.jsglue data";
                  return _context.abrupt("return", result);

                case 12:
                  if (!this.jsglue_go) {
                    _context.next = 17;
                    break;
                  }

                  jsglue_go = dependencies_data.get("actor.jsglue_go");

                  if (!(null == jsglue_go)) {
                    _context.next = 17;
                    break;
                  }

                  result.status = "Evaluation failed, has no actor.jsglue_go data";
                  return _context.abrupt("return", result);

                case 17:
                  args = new Map();
                  _context.t0 = _regeneratorRuntime.keys(this.parameters);

                case 19:
                  if ((_context.t1 = _context.t0()).done) {
                    _context.next = 29;
                    break;
                  }

                  parameter = _context.t1.value;
                  ArgName = this.parameters[parameter].ArgName;
                  arg_data = dependencies_data.get(ArgName);

                  if (!(null == arg_data)) {
                    _context.next = 26;
                    break;
                  }

                  result.status = "Evaluation failed, has no " + ArgName + " data";
                  return _context.abrupt("return", result);

                case 26:
                  args.set(ArgName, arg_data);
                  _context.next = 19;
                  break;

                case 29:
                  wasm_wrapper = null;
                  if (jsglue_go) wasm_wrapper = new global.WasmGo(wasm, jsglue_go);else wasm_wrapper = new global.Wasm(wasm, jsglue);
                  _context.next = 33;
                  return wasm_wrapper.init();

                case 33:
                  result = _context.sent;

                  if (!("ok" === result.status)) {
                    _context.next = 39;
                    break;
                  }

                  _context.next = 37;
                  return wasm_wrapper.exec(args);

                case 37:
                  result = _context.sent;

                  if ("ok" === result.status) {
                    if (this.manifest) {
                      mime = this.manifest.get_mime();
                      if ("ok" === mime.status) result.data.MIME = mime.data;
                    }
                  }

                case 39:
                  _context.next = 41;
                  return wasm_wrapper.un_init();

                case 41:
                  return _context.abrupt("return", result);

                case 42:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function _eval(_x) {
          return _eval2.apply(this, arguments);
        }

        return _eval;
      }()
    }]);

    return _class;
  }();
})();